// primary statuses
export const PST = {
  DRAFT: {
    id: 0,
    name: 'DRAFT'
  },
  REVIEW: {
    id: 1,
    name: 'REVIEW'
  },
  APPROVED: {
    id: 2,
    name: 'APPROVED'
  },
  UNPUBLISHED: {
    id: 10,
    name: 'UNPUBLISHED'
  },
  ARCHIVED: {
    id: 3,
    name: 'ARCHIVE'
  },
};
// primary actions
export const PACT = {
  DRAFT: {
    id: 0,
    name: 'DRAFT',
    icon: 'set-to-draft-icon',
  },
  REVIEW: {
    id: 1,
    name: 'REVIEW',
    icon: 'set-to-review-icon',
  },
  APPROVE: {
    id: 2,
    name: 'APPROVE',
    icon: 'set-to-approved-icon',
  },
  PUBLISH: {
    id: 8,
    name: 'PUBLISH',
    icon: 'set-to-publish-icon',
  },
  UNPUBLISH: {
    id: 10,
    name: 'UNPUBLISH',
    icon: 'set-to-unpublish-icon',
  },
  ARCHIVE: {
    id: 3,
    name: 'ARCHIVE'
  },
  EXPORT_SELECTED: {
    id: 9999,
    name: 'EXPORT_SELECTED',
    icon: 'export-icon',
  },
  EXPORT_SELECTED_TO_RECEIVER: {
    id: 10000,
    name: 'EXPORT_SELECTED_TO_RECEIVER',
    icon: 'export-to-receiver-icon',
  },
  COPY_SELECTED: {
    id: 10001,
    name: 'COPY_SELECTED',
    icon: 'export-icon',
  },
};
// secondary actions
export const SACT = {
  VIEW_DETAILS: {
    id: 0,
    name: 'VIEW_DETAILS'
  },
  EDIT_SELECTED: {
    id: 1,
    name: 'EDIT_SELECTED'
  },
  VIEW_SELECTED: {
    id: 2,
    name: 'VIEW_SELECTED'
  },
  BULK_EDIT: {
    id: 4,
    name: 'BULK_EDIT'
  },
};
// list actions
export const LACT = {
  ADD_TO_LIST: {
    id: 0,
    name: 'ADD_TO_LIST'
  },
  REMOVE_FROM_LIST: {
    id: 1,
    name: 'REMOVE_FROM_LIST'
  },
};
